import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { createCommercialCombo, getAllCommercials } from "../../../services";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { filterItems } from "../../../functions/funciones";

const NuevoComercialCombo = () => {
  const { t } = useTranslation('common');
  const [commercials, setCommercials] = useState([]);

  const [busqueda, setBusqueda] = useState([]);
  const [resultados, setResultados] = useState();

  const [comercial, setComercial] = useState({});
  const [selected, setSelected] = useState([])
  

  useEffect(() => {
    getAllCommercials({onlyPrimary: true}).then((res) => {
      const comerciales = [];
      res.forEach((c) => {
        comerciales.push({
          id: c.id,
          nif: c.nif,
          nombre: c.nombre,
          apellidos: c.apellidos,
          busqueda: c.nombre + " " + c.apellidos,
          userId: c.user[0]?.id
        });
      });
      setResultados(comerciales);
      setCommercials(comerciales);
    });
  }, [])

  function handleSubmit(e) {
    e.preventDefault();
    const toastInfo = toast.info(t('commercials.messages.saving'));
    if (selected.length == 0) {
      return toast.update(toastInfo, {
        render: t('commercials.noCommercials'),
        type: toast.TYPE.ERROR,
        autoClose: true,
      });
    }
    createCommercialCombo({...comercial, userIds: selected.map(s => s.userId)})
      .then((res) => {
        if (res.status == 201) {
          toast.update(toastInfo, {
            render: t('commercials.messages.createdSuccess'),
            type: toast.TYPE.SUCCESS,
            autoClose: true,
          });

          window.location.replace("/comerciales");
        }else if (res.status == 403) {
          toast.update(toastInfo, {
            render: t('commercials.messages.createError'),
            type: toast.TYPE.ERROR,
            autoClose: true,
          });
        } else {
          toast.update(toastInfo, {
            render: t('messages.error'),
            type: toast.TYPE.ERROR,
            autoClose: true,
          });
        }


      })
      .catch((err) => {
        console.log(err);
        toast.error(t('commercials.messages.createError'));
      });
  }
  function handleChange(evt) {
    const value = evt.target.value;
    setComercial({
      ...comercial,
      [evt.target.name]: value,
    });
  }


  const buscar = (e) => {
    // e.preventDefault();
    
    setResultados(filterItems(busqueda, commercials.filter(c => !selected.some(s => s.id === c.id))))
  };
  useEffect(buscar, [busqueda]);
  const select = (comercial) => {
    setSelected([...selected, comercial]);
    setResultados(resultados.filter(c => c.id !== comercial.id));
  }
  
  const unselect = (comercial) => {
    const newSelected = selected.filter(c => c.id !== comercial.id)
    setSelected(newSelected);
    setResultados(commercials.filter(c => !newSelected.some(s => s.id === c.id)));
  }
  

  return (
    <>
      {/* <div
        className="pageHeader"
        style={{
          backgroundImage: `url(${HeaderBackground})`,
          textAlign: "left",
        }}
      >
        Comerciales / <b>Nuevo</b>
      </div> */}
      <BreadCrumb rutas={[{path:`/comerciales`, label: t('commercials.title')}, {path:`/comerciales`, label: t('commercials.newCombo')}]} style={{ margin: '0 10px'}} />
      <div className="pageContent">
        <div className="gridHead">{t('commercials.createNewCombo')}</div>
        <form className="nuevoAAFFForm" onSubmit={handleSubmit}>
          <input
                type="text"
                required
                placeholder={t('form.name')}
                name="nombre"
                value={comercial.nombre}
                onChange={handleChange}
              ></input>

                <div className="tableContainer" style={{ marginTop: 30, marginBottom: 30, padding: 0 }}>
            <table>
              <thead>
                <tr>
                  <th>{t('commercials.titleSingular')}</th>
                  <th>{t('form.nif')}</th>
                  <th style={{ textAlign: "center" }}>{t('actions.delete')}</th>
                </tr>
              </thead>
              <tbody>
                {selected.length == 0 ? <tr><td colSpan={3} style={{ textAlign: "center" }}>{t('commercials.selectCommercials')}</td></tr> : selected.map((e, i) => {
                  return (
                    <tr key={i}>
                      <td>{e.nombre + " " + e.apellidos}</td>
                      <td>{e.nif}</td>
                      <td style={{ textAlign: "center" }}>
                        <div
                          className="asignarButton"
                          style={{
                            marginLeft: "auto",
                            marginRight: "auto",
                            cursor: "pointer",
                          }}
                          onClick={() => unselect(e)}
                        >
                          {t('actions.delete')}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <input
            type="submit"
            value={t('actions.save')}
          ></input>
        </form>
        <form className="nuevoAAFFForm" onSubmit={e => e.preventDefault()}>
              <input
                  type="text"
                  placeholder={t('commercials.searchCommercial')}
                  required
                  value={busqueda}
                  onChange={(e) => setBusqueda(e.target.value)}
                ></input>
                </form>
          <div className="tableContainer" style={{ marginTop: 10 }}>
            <table>
              <thead>
                <tr>
                  <th>{t('commercials.titleSingular')}</th>
                  <th>{t('form.nif')}</th>
                  <th style={{ textAlign: "center" }}>{t('actions.add')}</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(resultados) ? resultados.map((e, i) => {
                  return (
                    <tr key={i}>
                      <td>{e.nombre + " " + e.apellidos}</td>
                      <td>{e.nif}</td>
                      <td style={{ textAlign: "center" }}>
                        <div
                          className="asignarButton"
                          style={{
                            marginLeft: "auto",
                            marginRight: "auto",
                            cursor: "pointer",
                          }}
                          onClick={() => select(e)}
                        >
                          {t('actions.add')}
                        </div>
                      </td>
                    </tr>
                  );
                }) : 
                <tr><td colSpan={3} style={{ textAlign: "center" }}><CircularProgress style={{color:'#92004D'}} /></td></tr>
                }
              </tbody>
            </table>
          </div>
          
      </div>
    </>
  );
};

export default NuevoComercialCombo;
